import { apiClient } from './axiosInstance';

export const fetchCurrencies = async () => {
  return await apiClient.get(`/currencies`);
};
